import { useEffect, useState } from 'react';
import { db } from "@react-native-firebase/database";
import { get, ref, set } from "firebase/database";
import StyleSheetRW from 'core/StyleSheetRW';
import { Dimensions, ScrollView, Text, TextInput, TouchableOpacity, View } from 'react-native';
import { MOBILE_VIEW_WIDTH } from "res/constants";
import { getLocalStorageItem } from 'core/helpers';
import Dialog from 'src/components/Dialog';
import Menu from '../Menu';
import Loader from 'src/components/Loader';
import { textFieldFilteration } from 'src/utils/TextFieldUtils';

const AdminProfileScreen = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        userTypeId: 1 ,
        employmentStatus: "Active"
    });
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [showLoader, setShowLoader] = useState(false);


    const handleChange = (name: string, value: string,type:string) => {
        let filteredValue =textFieldFilteration(value,type)
        setFormData({ ...formData, [name]: filteredValue });
    };

    const screenWidth = Dimensions.get('window').width;
    const loggedinUser = getLocalStorageItem("loggedinUser");

    const handleSubmit = async () => {
        setShowLoader(true)
        if (loggedinUser) {
            const updatedFormData = { ...formData, employmentStatus: formData.employmentStatus || "Active" };
            const allFieldsFilled = Object.entries(updatedFormData).every(([key, value]) => {
                return value !== '';
            });

            if (!allFieldsFilled) {
                setShowLoader(false)
                setShowToast(true);
                setToastMessage("Please fill in all required fields.");
                return;
            }

            const dbRef = ref(db, `profile/${loggedinUser.uid}`);
            await set(dbRef, updatedFormData)
                .then(() => {
                    setShowLoader(false)
                    setShowToast(true);
                    setToastMessage("Profile updated successfully");
                })
                .catch((error) => {
                    console.error("Error updating profile:", error);
                    setShowLoader(false)
                    setShowToast(true);
                    setToastMessage(`Error updating profile: ${error}`);
                });
        }
    };

    useEffect(() => {
        setShowLoader(true)
        const fetchUserData = async () => {
            if (loggedinUser) {
                const dbRef = ref(db, `profile/${loggedinUser.uid}`);
                const snapshot = await get(dbRef);
                if (snapshot.exists()) {
                    setFormData(snapshot.val());
                    setShowLoader(false)
                } else {
                    setShowLoader(false)
                }
            }
        };

        setUserEmail(loggedinUser?.email);
        fetchUserData();
    }, []);


    return (
        <div style={{ display: 'flex', flexDirection: 'row', height: '100%', maxHeight: '100%' }}>
            <Menu backEnabled={false} />
            <View style={styles.container}>
                <ScrollView showsVerticalScrollIndicator={false} showsHorizontalScrollIndicator={false} style={{ padding: 20, width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "80%" }}>
                    <View style={styles.header}>
                        <Text style={styles.heading}>Profile</Text>
                        {screenWidth > MOBILE_VIEW_WIDTH && (
                            <TouchableOpacity style={styles.button} onPress={handleSubmit}>
                                <Text style={styles.buttonText}>Save Changes</Text>
                            </TouchableOpacity>
                        )}
                    </View>
                    <View style={styles.form}>
                        <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
                            <View style={styles.inputContainer}>
                                <Text style={{ ...styles.label, marginTop: 5 }}>First Name</Text>
                                <TextInput
                                    style={styles.input}
                                    placeholder="First Name"
                                    value={formData.firstName}
                                    onChangeText={(text) => handleChange('firstName', text,'text')}
                                />
                            </View>
                            <View style={styles.inputContainer}>
                                <Text style={{ ...styles.label, marginTop: 5 }}>Last Name</Text>
                                <TextInput
                                    style={styles.input}
                                    placeholder="Last Name"
                                    value={formData.lastName}
                                    onChangeText={(text) => handleChange('lastName', text,'text')}
                                />
                            </View>
                        </View>
                        <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
                            <View style={styles.inputContainer}>
                                <Text style={{ ...styles.label, marginTop: 0 }}>Email</Text>
                                <TextInput
                                    style={{ ...styles.input, width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "48.2%" }}
                                    placeholder="Email"
                                    value={userEmail}
                                    editable={false}
                                />
                            </View>
                        </View>
                        {screenWidth < MOBILE_VIEW_WIDTH && (
                            <TouchableOpacity style={{ ...styles.button, marginBottom: 10 }} onPress={handleSubmit}>
                                <Text style={styles.buttonText}>Save Changes</Text>
                            </TouchableOpacity>
                        )}
                    </View>
                </ScrollView>
            </View>

            <Dialog
                message={toastMessage}
                isDialogVisible={showToast}
                handleDialogConfirm={() => setShowToast(false)}
            />
            {
                showLoader && (
                    <Loader />
                )
            }
        </div>
    );
};

const styles = StyleSheetRW.create(() => ({
    container: {
        flex: 1,
        width: "100%",
        height: "100%",
    },
    heading: {
        fontFamily: "Outfit",
        fontSize: 32,
        fontWeight: 'bold',
        textAlign: "left",
        color: "#2F4858",
    },
    subheading: {
        fontFamily: 'Outfit',
        fontSize: 18,
        fontWeight: 'bold',
        color: '#2F4858',
        marginTop: 10,
    },
    form: {
        width: '100%',
        height: '100%',
        marginTop: 20,
    },
    row: {
        justifyContent: 'space-between',
        marginBottom: 10,
        gap: 20
    },
    inputContainer: {
        flex: 1,
        marginRight: 5,
    },
    label: {
        fontFamily: 'Outfit',
        fontSize: 14,
        fontWeight: '600',
        lineHeight: 17.64,
        textAlign: 'left',
        marginBottom: 5,
        color: '#333333',
    },
    input: {
        height: 50,
        borderRadius: 10,
        paddingHorizontal: 10,
        backgroundColor: '#0000000D',
        marginTop: 3,
        placeholderTextColor: '#333333',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    button: {
        backgroundColor: '#2F4858',
        paddingVertical: 10,
        paddingHorizontal: 20,
        borderRadius: 100,
    },
    buttonText: {
        color: 'white',
        fontWeight: "300",
        textAlign: "center",
    },
    line: {
        borderBottomWidth: 1,
        borderColor: '#2F4858',
        marginBottom: 10,
    },
}))

export default AdminProfileScreen;